import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CopyableChip from '@/common-utils/components/renders/copyableChip/CopyableChip';
import { Button } from '@/common-utils/components/ui/button';
import ICONS from '../../../common-utils/enums/icons';
import useErrorStore from '../../store/error';
import PropTypes from 'prop-types';

/**
 *
 * @param {Object} props
 * @param {Error} props.error
 * @param {function} props.resetErrorBoundary
 * @returns {JSX} ErrorFallBack
 */
function ErrorFallBack({ error, resetErrorBoundary }) {
    // URL Params
    const location = useLocation();
    const info = useErrorStore(s => s.error);

    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (info) {
            setErrorMessage(`${error.message.trim()} ${info?.split('\n')[1].trim()} when accessing ${location.pathname}${location.search}`);
        }
    }, [info]);

    return (
        <div className='flex flex-col mx-auto h-screen mt-8 gap-2 items-center'>
            <h1 className='mb-8'>Impossible d'afficher cette page</h1>
            <p>Nous n'avons pas pu afficher cette page en raison d'une erreur.</p>
            <p>
                Veuillez réessayer dans quelques instants.
                Si le problème persiste, contactez le support.</p>
            <p className='mt-8'>Détails techniques :</p>
            <CopyableChip text={errorMessage} className='text-md font-normal max-w-[700px]' />
            <Button
                onClick={resetErrorBoundary}
                icon={ICONS.ARROW_LEFT}
                variant={'primary'}
                entity={'Retourner à l\'accueil'}
                className='h-12 rounded-lg px-4 mt-8 '
            />
        </div>
    );
}

ErrorFallBack.propTypes = {
    error: PropTypes.object.isRequired,
    resetErrorBoundary: PropTypes.func.isRequired
};

export default ErrorFallBack;